import axiosapi from "./axiosAPI";

// Get Monitor Stats
export const getMonitorStats     = async (
    setMonitorStats,
    user_id,
    setFetcherror,
) => {
    
	try{
		const res =await axiosapi.get(`/monitordashboard/${user_id}`);
        setMonitorStats(res.data ? res.data.data : {});
        return res.data.data;
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Categories");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Categories");
		}
		
	}
	
};

// Get  Main Dashboard Stats
export const mainDashboardStats     = async (
    setMainDashboardStats,
    setFetcherror,
    setIsLoading,
    params = {}
) => {
    
	try{
		const res =await axiosapi.get("/admindashboard", { params });
        setMainDashboardStats(res.data ? res.data.data : {});
        setIsLoading(false);

	}
	catch(err){
		if(err.response){
            setFetcherror("Error Occured");
            setIsLoading(false);
		}else{
			//No response Obtained from the server.
            setFetcherror("Error Occured");
            setIsLoading(false);
		}
		
    }
    finally{
        setFetcherror("");
        setIsLoading(false);
    }
	
};
